import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.survey.listSurvey

function* listSurveySagaTask() {
    try {
        const response = yield axios.get('/meeting/survey')
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSurveySaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSurveySagaTask)
}

export default listSurveySaga
